var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "10px",
    viewBox: "0 0 7 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "817432C4-2A93-4B33-9EF7-89119E07990F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sales-Package",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sales->-Sub->-Lead-Listing->-Custom-Views-Manager",
    transform: "translate(-383.000000, -404.000000)",
    fill: "#CF323F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.5,404.5 C388.309832,404.5 388.923495,405.369775 388.993133,407.664705 L389,408 C389.552285,408 390,408.447715 390,409 L390,413 C390,413.552285 389.552285,414 389,414 L384,414 C383.447715,414 383,413.552285 383,413 L383,409 C383,408.447715 383.447715,408 384,408 C384.021165,405.453943 384.604622,404.5 386.5,404.5 Z M386.623864,405.501723 L386.5,405.5 C385.312223,405.5 385.019749,405.937045 385.000991,407.923989 L385,408 L387.999588,407.999575 C387.987883,406.020449 387.722441,405.533604 386.623864,405.501723 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.0d4ebd709275ef91461b2b24c7e0fa2e.svg";
export { ForwardRef as ReactComponent };